/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterSortADefaultIcon16Regular = forwardRef('UiFilterSortADefaultIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.25 4A.75.75 0 0 1 3 3.25h6a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 4Z" }),
        React.createElement("path", { d: "M2.25 12a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M3 7.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H3Z" })));
});
